export default __webpack_public_path__ + "static/media/split.17c05cb0.png";